module.exports = __webpack_public_path__ + "img/career-history.5476e2ac.svg";